import InputSwitchList from './InputSwitchList'

export default InputSwitchList
